export const dp_s2 = '0.125rem';
export const dp_s4 = '0.25rem';
export const dp_s8 = '0.5rem';
export const dp_s12 = '0.75rem';
export const dp_s16 = '1rem';
export const dp_s24 = '1.5rem';
export const dp_s32 = '2rem';
export const dp_s40 = '2.5rem';
export const dp_s48 = '3rem';
export const dp_s64 = '4rem';
export const dp_s80 = '5rem';
export const dp_s96 = '6rem';
